import {
  BREAKPOINT_TABLET,
  FONT_SIZE_EXTRA_SMALL,
  FONT_SIZE_SMALL,
  NAV_HEIGHT_PX,
  BREAKPOINT_MOBILE,
  BREAKPOINT_DESKTOP_LG,
} from "../../../constants/constants";
import styled, { css } from "styled-components/macro";
import {
  medGrey,
  darkModeTextColor,
  darkGrey,
  lightTextLink,
  darkBlue,
  lightGrey,
} from "../../../constants/colors";

const BTN_FILTERS_WIDTH = 48;
const BTN_FILTERS_HEIGHT = 48;
export const FilterStateDisplayStyles = styled.div<{
  $isDarkMode: boolean;
  $isFiltered: boolean;
}>`
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          color: ${darkModeTextColor};
        `
      : ""}

  width: 100%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  padding: 8px 0;
  min-height: ${NAV_HEIGHT_PX}px;
  height: fit-content;
  box-sizing: border-box;
  .MuiMenuItem-root.active {
    background-color: ${lightGrey};
    pointer-events: none;
  }
  .filtersWrapper {
    width: fit-content;
    margin-left: 32px;
    position: relative;
    display: flex;
    @media (max-width: ${BREAKPOINT_TABLET}px) {
      flex-wrap: wrap;
      row-gap: 1em;
    }
    align-items: center;
    justify-content: left;
    padding-left: 24px;
    box-sizing: border-box;
    min-height: ${BTN_FILTERS_HEIGHT}px;
    width: 100%;
    max-width: calc(100% - ${2 * BTN_FILTERS_WIDTH}px);
  }
  .noFilters {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 6px;
  }

  .btnFilters {
    position: absolute;
    padding: 10px;
    left: 4px;
    top: 0;
    bottom: 0;
    display: flex;
    border-radius: 8px !important;
    height: ${BTN_FILTERS_HEIGHT}px;
    width: ${BTN_FILTERS_WIDTH}px;
  }
  .btnClearAllFilters {
    margin-left: auto;
    @media (min-width: ${BREAKPOINT_DESKTOP_LG}px) {
      margin-left: 12px;
    }
    white-space: nowrap;
    border: none;
    color: ${lightTextLink};
    font-weight: bold;
    line-height: 17px;
    text-transform: none;
    font-size: 14px;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
      color: ${darkGrey};
    }
  }
  .trendsFilterChip {
    background: white;
    transition: background 0.3s;
    &.active {
      background: ${darkBlue};
      .filterValue,
      .filterText {
        color: white;
      }
    }
    color: #a0a0a0;
    border: 1px solid #a0a0a0;
    &.active {
      color: ${darkGrey};
      border: 1px solid ${darkGrey};
    }
    box-sizing: border-box;
    padding: 5px 15px;
    height: 29px;
    margin: 0 4px 0 3px;
    @media (max-width: ${BREAKPOINT_MOBILE}px) {
      margin: 10px 3px;
    }
    max-width: 100%;
    border-radius: 999px;
    &.disabled {
      text-decoration: line-through;
      background: ${medGrey};
    }
    .MuiChip-deleteIcon {
      color: ${medGrey};
      transition: color 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
      margin: 0 -12px 0 -4px;
      transform: scale(0.8) translateY(1px);
      transform-origin: right center;
      &:hover {
        color: ${darkGrey};
      }
    }
    .MuiSvgIcon-root {
      width: 1.7rem;
      height: auto;
    }
    .MuiChip-label {
      font-size: ${FONT_SIZE_SMALL}px;
      padding: 0 12px 0 0;
      overflow: visible;
    }
    .filterType {
      color: white;
      font-size: ${FONT_SIZE_EXTRA_SMALL}px;
    }
    .filterText,
    .filterValue {
      color: black;
    }
    .filterText {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 15px;
    }
    .filterValue {
      &.inactive {
        opacity: 0.5;
      }
    }
  }
  .btnFilters {
    width: 28px;
    height: 28px;
    box-sizing: content-box;
    ${({ $isFiltered }) =>
      !$isFiltered
        ? css`
            padding-right: calc(100vw - 92px);
          `
        : ""}
  }
  .btnFilters {
    margin: auto;
  }
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    align-items: center;
    .btnFilters {
      margin: auto 4px;
    }
  }
`;
